import * as React from 'react';
import { Droppable } from 'react-beautiful-dnd';

import palette from 'ui/theme/palette';

interface Props {
  id: string;
  type: string;
  dataCy?: string;
  children?: React.ReactNode;
  /**
   * Wraps the items AND the drag placeholder. Wrapping <Drop>'s children instead leaves the
   * placeholder outside, and the list visibly collapses mid-drag.
   */
  renderContainer?: (content: React.ReactNode) => React.ReactNode;
  /** Inside the droppable, outside `renderContainer` — keeps an empty list tall enough to drop onto. */
  footer?: React.ReactNode;
}

export const Drop: React.FC<Props> = (props) => {
  const getListStyle = (isDraggingOver: boolean) => ({
    background: isDraggingOver ? palette.info.screen : 'transparent',
    width: '100%'
  });

  return (
    <Droppable droppableId={props.id} type={props.type}>
      {(droppableProvided, droppableSnapshot) => (
        <div
          {...droppableProvided.droppableProps}
          ref={droppableProvided.innerRef}
          style={getListStyle(droppableSnapshot.isDraggingOver)}
          data-cy={props.dataCy}
        >
          {props.renderContainer ? (
            props.renderContainer(
              <>
                {props.children}
                {droppableProvided.placeholder}
              </>
            )
          ) : (
            <>
              {props.children}
              {droppableProvided.placeholder}
            </>
          )}
          {props.footer}
        </div>
      )}
    </Droppable>
  );
};
